export const ENV = {
  PRODUCTION: 'https://www.mawoopets.com',
  QA: 'https://mawoo-qa.vercel.app/',
  DEVELOPMENT: 'http://localhost:3000',
}

export const ROBOTS_META =
  process.env.NEXT_PUBLIC_ROOT_URL === ENV.PRODUCTION
    ? 'index, follow'
    : 'noindex, nofollow'
